// Pricing engine — 5 modes: standard, flat, pct, per_head, complimentary
// A line item shape:
// { id, name, sub, qty, rate, pricing_mode, discount_value, reason_code, override_amount, edited }
// Returns { was, now, saving } for display + persistence.

export const MODES = [
  { key: 'standard',      label: 'Standard' },
  { key: 'flat',          label: 'Flat discount (₹)' },
  { key: 'pct',           label: 'Percentage discount (%)' },
  { key: 'per_head',      label: 'Per-head discount (₹/person)' },
  { key: 'complimentary', label: 'Complimentary (₹0)' },
];

export function computeLine(line) {
  const qty = Number(line.qty || 0);
  const rate = Number(line.rate || 0);
  const base = qty * rate;
  const mode = line.pricing_mode || 'standard';
  let now = base, saving = 0;
  if (mode === 'flat') {
    saving = Math.min(Number(line.discount_value || 0), base);
    now = Math.max(base - saving, 0);
  } else if (mode === 'pct') {
    saving = Math.round(base * Math.min(Math.max(Number(line.discount_value || 0), 0), 100) / 100);
    now = Math.max(base - saving, 0);
  } else if (mode === 'per_head') {
    saving = qty * Number(line.discount_value || 0);
    now = Math.max(base - saving, 0);
  } else if (mode === 'complimentary') {
    saving = base;
    now = 0;
  }
  if (line.override_amount != null && line.override_amount !== '') {
    saving = Math.max(base - Number(line.override_amount), 0);
    now = Number(line.override_amount);
  }
  return {
    was: base,
    now,
    saving,
    is_complimentary: mode === 'complimentary' || now === 0,
    is_discounted: saving > 0 && now > 0,
  };
}

export function computeDocument(eventGroups, travelLines = [], packageDiscount = 0) {
  let subtotal = 0, discountedGross = 0, valueGivenAway = 0;
  const enriched = (eventGroups || []).map(g => {
    const items = (g.services || []).map(l => {
      const c = computeLine(l);
      subtotal += c.was;
      discountedGross += c.now;
      valueGivenAway += c.saving;
      return { ...l, ...c };
    });
    const eventSubtotal = items.reduce((s, i) => s + i.now, 0);
    const eventTravel = (g.travel_lines || []).reduce((s, l) => s + Number(l.amount || 0), 0);
    return { ...g, services: items, event_subtotal: eventSubtotal, event_travel: eventTravel };
  });
  const globalTravel = (travelLines || []).reduce((s, l) => s + Number(l.amount || 0), 0);
  const preDiscount = discountedGross + globalTravel + enriched.reduce((s, g) => s + g.event_travel, 0);
  const total = Math.max(preDiscount - Number(packageDiscount || 0), 0);
  valueGivenAway += Number(packageDiscount || 0);
  return { subtotal, discountedGross, total, valueGivenAway, enriched, globalTravel };
}
